import React from 'react';
import { antiMoneyQuestionsConditions, antiMoneyQuestionsList } from 'const/questionsAntiMoney';
import { isMobile } from 'react-device-detect';
import { View } from '@coinscrap/webapp-core';
import InputLabel from 'components/InputLabel/InputLabel';
import { OptionButton } from 'components/OptionButton/OptionButton';




export const PbcQuestions = ({
	fundsOrigin,
	userDocumentType,
	antiMoneyQuestionsReponses,
	setAntiMoneyQuestionsReponses,
}) => {
	return antiMoneyQuestionsList.map((question) => (
		<View inputFreeRowSt key={question.id}>
			{antiMoneyQuestionsConditions(
				question,
				fundsOrigin,
				userDocumentType,
				antiMoneyQuestionsReponses,
			) && (
					<>
						{question.type === 'BOOLEAN' && (
							<InputLabel label={question.description} type="custom">
								<View
									rowSt
									justifyStartSt
									style={{
										gap: isMobile ? '20px' : '12px',
										flexWrap: 'wrap',
									}}
								>
									<OptionButton
										onClick={() =>
											setAntiMoneyQuestionsReponses((prevState) => {
												return {
													...prevState,
													[question.id]: true,
												};
											})
										}
										selected={antiMoneyQuestionsReponses[question.id] === true}
										text={'Sí'}
										style={{
											width: isMobile ? '100%' : undefined,
											margin: isMobile ? 0 : undefined,
										}}
									/>
									<OptionButton
										onClick={() =>
											setAntiMoneyQuestionsReponses((prevState) => {
												const newState = { ...prevState };
												antiMoneyQuestionsList.map((qs) => {
													if (qs.id === question.id) {
														newState[qs.id] = false;
													} else if (
														(qs?.dependencyQuestionNumber?.includes(
															question.id,
														) ||
															qs?.dependencyQuestionNumber?.includes(
																'ALL',
															)) &&
														qs.id > question.id
													) {
														switch (typeof newState[qs.id]) {
															case 'string':
																newState[qs.id] = '';
																break;
															default:
																newState[qs.id] = undefined;
																break;
														}
													}
													return qs;
												});
												return newState;
											})
										}
										selected={antiMoneyQuestionsReponses[question.id] === false}
										text={'No'}
										style={{
											width: isMobile ? '100%' : undefined,
											margin: isMobile ? 0 : undefined,
										}}
									/>
								</View>
							</InputLabel>
						)}

						{question.type === 'STRING' && (
							<InputLabel
								label={question.description}
								style={{
									width: '100%',
									maxWidth: 700,
									input: {
										minHeight: 75,
									},
								}}
								value={antiMoneyQuestionsReponses[question.id]}
								onChange={(e) => {
									const val = e.target.value;
									setAntiMoneyQuestionsReponses((prevState) => {
										return {
											...prevState,
											[question.id]: val,
										};
									});
								}}
							/>
						)}

						{question.type === 'SELECT' && (
							<InputLabel label={question.description} type="custom">
								<View
									rowSt
									justifyStartSt
									style={{
										gap: isMobile ? '20px' : '12px',
										flexWrap: 'wrap',
									}}
								>
									{question.selectValues.map((item) => {
										return (
											<OptionButton
												key={item.label}
												width="auto"
												onClick={() =>
													setAntiMoneyQuestionsReponses((prevState) => {
														return {
															...prevState,
															[question.id]: item.alzvalue,
														};
													})
												}
												selected={
													antiMoneyQuestionsReponses[question.id] ===
													item.alzvalue
												}
												text={item.label}
												style={{
													width: isMobile ? '100%' : undefined,
													margin: isMobile ? 0 : undefined,
												}}
											/>
										);
									})}
								</View>
							</InputLabel>
						)}
					</>
				)}
		</View>
	));
};
